const numLink = [null];

for (let i = 1; i <= 2000; i++) {
  numLink.push(String(i).padStart(4, '0'));
}

export default numLink;